import { IDictionary } from "./interfaces/IDictionary";

const EN: IDictionary = {
    "": "",
    "—": "—",
    "%": "%",
    "°": "°",
    "°C": "°C",
    "1": "1",
    "2": "2",
    "3": "3",
    aboutAccount: "About account",
    aboveAverage: "Above average",
    trackerModeAttention: "В режиме трекера расход батареи увеличен!",
    accelerometerAmp: "Motion sensor sensitivity",
    accelerometerAmpTooltip:
        "The higher the sensitivity of the sensor, the lower the traffic threshold required to send a message",
    action: "Action",
    active: "Active",
    activeAlarms: "Active alarms",
    activeServers: "Active servers",
    add: "Add",
    addDevice: "Add a device",
    addDeviceInDb: "Add a new device to the database",
    addDeviceInOldDb: "Unable to add an account",
    addDeviceInOldDbSuccess: "Success adding account Vega-M",
    addDevicesTitle: "Add devices",
    addDeviceToGroup: "Add to group",
    addDeviceTitle: "Add a device",
    addDeviceToSubuserAccount: "Add a device to user account",
    addDeviceToSubuserTitle: "Adding a device to user account",
    addGroup: "Create a new group",
    addGroupTitle: "Create a new group",
    additionally: "Additionally",
    addObject: "Add an item",
    address: "Address",
    addSubuserTitle: "Create a new user",
    advancedGnssReceiverSetup: "Advanced GNSS receiver setup",
    advancedSettings: "Advanced settings",
    agree: "Agree",
    alarm: "Alarm",
    alarm_1: "Alarm №1",
    Alarm_1: "Alarm №1",
    ALARM_1: "Alarm №1",
    alarm_2: "Alarm №2",
    Alarm_2: "Alarm №2",
    ALARM_2: "Alarm №2",
    alarm_3: "Alarm №3",
    Alarm_3: "Alarm №3",
    ALARM_3: "Alarm №3",
    alarm_4: "Alarm №4",
    Alarm_4: "Alarm №4",
    ALARM_4: "Alarm №4",
    alarm_5: "Alarm №5",
    Alarm_5: "Alarm №5",
    ALARM_5: "Alarm №5",
    alarm_6: "Alarm №6",
    Alarm_6: "Alarm №6",
    ALARM_6: "Alarm №6",
    alarm1: "Alarm №1",
    alarm2: "Alarm №2",
    alarm3: "Alarm №3",
    alarm4: "Alarm №4",
    alarm5: "Alarm №5",
    alarm6: "Alarm №6",
    allGroups: "All groups",
    altitude: "Altitude",
    alwaysEnabled: "Always enabled",
    animal: "Animal",
    animalKind: "Animal kind",
    animalName: "Animal name",
    applyToOtherDevices: "Apply to other devices",
    authentication: "Login to account",
    authError: "Authorisation error",
    authMainText: "Functional GPS monitoring for business and beyond",
    authenticationOld: "Import old account",
    back: "Back",
    backToAuth: "Back to the authorisation page",
    batteryCharge: "Battery charge",
    batteryState: "Battery status",
    batteryVoltage: "Battery voltage",
    belowAverage: "Below average",
    birthYear: "Birth year",
    bootVer: "Bootloader version",
    bootVerError: "Invalid bootloader version",
    brand: "Brand",
    bulkAddDevices: "Bulk add devices",
    callbackPhoneNumber: "Callback phone number",
    cancel: "Cancel",
    car: "Car",
    carBrand: "Car brand",
    carModel: "Car model",
    carNumber: "Car number",
    carVin: "Car vin",
    cell_id: "Cell ID",
    changeSettingsShort: "Изменение настроек",
    changeSettings: "Rights to change device settings",
    changeSubuserPassword: "Change user password",
    charge: "Charge",
    close: "Close",
    closeTelemetry: "Close telemetry",
    color: "Color",
    company: "Company",
    companyTaxpayerNumber: "Company taxpayer number",
    confirm: "Confirm",
    confirmationCode: "Confirmation code",
    confirmationErr: "An error occurred while confirming registration",
    confirmationHasBeenSended:
        "Confirmation code has been sent to you by email",
    confirmationHasBeenSendedAgain:
        "Confirmation code has been sent to you by email again",
    confirmDeviceDeleteWarning: "Are you sure you want to delete the device",
    confirmGroupDeleteWarning: "Are you sure you want to delete the group",
    confirmGroupDeleteWarningText:
        "Devices that are in the group will be moved to the default group",
    confirmPageTitle: "Registration confirmed",
    confirmPasswordSuccess: "Password has been successfully changed",
    confirmPasswordSuccessTitle: "Password recovered",
    confirmSettingsClose:
        "You have unsaved changes in settings, do you really want to close settings without saving?",
    confirmSubuserDeleteWarning: "Are you sure you want to delete the user",
    confirmSuccess: "You have been successfully registered in the system",
    confirmText: "Enter the confirmation code sent to you by email",
    confirmTitle: "Registration confirmation",
    connectionState: "Device communication status",
    contactTime: "Contact time",
    content: "Content",
    contractDate: "Contract date",
    contractNumber: "Contract number",
    control: "Control",
    cookiesPolicyAcceptance: "This site uses cookies for the work",
    coordinateTransmissionPeriod: "Coordinate transmission period",
    coordinateTransmissionPeriodHelper: "In minutes from 0 to 10",
    coordinateTransmissionPeriodMin: "Coordinate transmission period, min",
    coords: "Coordinates",
    coordsCopied: "Coordinates copied",
    coordsGPS: "GPS coordinates",
    coordsLBS: "LBS coordinates",
    coordTime: "Time of coordinates receiving",
    coordTxPeriodError: "Period must be from 0 to 10 minutes",
    coordTxPeriodTooltip:
        "Coordinate transmission period by the device to the server, in minutes (from 0 to 10 minutes)",
    coordType: "Coordinate type",
    copied: "Copied",
    create: "Create",
    createSubuser: "Create a new user",
    cur_sim: "Used SIM",
    currentState: "Current state",
    customDate: "Custom date range",
    darkDetect: "Light disappearance",
    DarkDetect: "Light disappearance",
    dataTransmission: "Data transmission",
    date: "Date",
    datePickerTitle: "Выберите дату",
    default: "Default",
    deleteSubuser: "Delete user",
    deliveryDate: "Delivery date",
    demo: "Demo",
    demoModeError: "Not possible in demo mode",
    determineCoordinatesByBaseStations:
        "Determine coordinates by base stations",
    determineCoordinatesBySatellites: "Determine coordinates by satellites",
    device: "Device",
    deviceAlreadyExistError:
        "The device has already been added by another user",
    deviceAlreadyExistInDbError:
        "The device has already been added in database",
    deviceContactedToday: "The device contacted today",
    deviceDelete: "Delete the device",
    deviceIcon: "Device icon",
    deviceIsMoving: "The device is moving",
    deviceIsStationary: "The device isn't moving",
    deviceName: "Device name",
    deviceNameError: "Enter device name",
    deviceNameTooltip:
        "The name under which the device should be displayed in the device list",
    deviceNotContactedFor3days:
        "The device didn't contact for more than 3 days",
    deviceNotContactedFor24hours:
        "The device didn't contact for more than 24 hours",
    deviceNotContactedToday: "The device didn't contact today",
    deviceNotContactedYet: "The device haven't contacted yet",
    devicePasswordTooltip:
        "Password to access the device (printed on the body of the device)",
    devices: "Devices",
    deviceSettings: "Device settings",
    deviceSettingsUnavailableAlert: "Device settings unavailable",
    deviceSettingsTitle: "Device settings",
    devicesNumber: "Total number of devices",
    devicesNumberLongTimeNoContact:
        "Number of devices, which didn't contact for 3 days",
    devicesNumberNoTelemetry: "Number of devices without telemetry",
    devicesNumberWithLowCharge: "Number of devices with less than 25% charge",
    deviceTimezoneTooltip: "Device time zone",
    deviceType: "Device type",
    deviceTypeTooltip: "Type of the object on which the beacon is installed",
    deviceTz: "device Time Zone",
    dir: "Course",
    disabled: "Disabled",
    disabled1: "Disabled",
    displayGroupOnTheMap: "Display the group on the map",
    dnsAddress: "DNS server address",
    dnsAddressTooltip: "DNS server IP address",
    download: "Download",
    downloadTemplate: "Download template",
    editDeviceDescription: "Edit the device description",
    editDeviceDescriptionTitle: "Editing the device description",
    editGroupDescription: "Edit the group description",
    editGroupDescriptionTitle: "Editing the group description",
    editGroupNameHelperText:
        "The group name mustn't match the name of an existing group",
    editing: "Editing",
    editSubuserDescription: "Edit the user password",
    editSubuserRights: "Change user rights on a device",
    editSubuserRightsTitle: "Changing rights on a device",
    editSubuserTitle: "Editing the user password",
    email: "Email",
    emailAlertMessage: "Email must contain '@' character and dot",
    emptyPasswordError: "Enter password",
    emptyTypeError: "Enter device type",
    enabled: "Enabled",
    enabled1: "Enabled",
    error: "Error",
    event: "Event",
    FIRST_START: "First start",
    firststart: "First start",
    firstStart: "First start",
    FirstStart: "First start",
    from25to50per: "From 25% to 50%",
    fromDate: "From",
    fromSubuser: "From user",
    ftpAddress: "Address",
    ftpAddressTooltip: "IP address or domain name of the FTP update server",
    ftpDirectory: "Directory",
    ftpDirectoryTooltip:
        "Directory in which the update file is located on the FTP server",
    ftpFilename: "File name",
    ftpFilenameTooltip: "Update file name",
    ftpLogin: "Login",
    ftpLoginTooltip: "Login for access the FTP update server",
    ftpPassword: "Password",
    ftpPasswordTooltip: "Password for access the FTP update server",
    ftpPort: "Port",
    ftpPortTooltip: "TCP port of the FTP update server",
    fullName: "Full name",
    fullNameOfInstallingEmployee: "Full name of installing employee",
    generateReport: "Generate a report",
    gnssMaxSearchTime: "Maximum operating time",
    gnssMaxSearchTime1: "Maximum GNSS receiver operating time",
    gnssMaxSearchTimeError: "Wrong value",
    gnssMaxSearchTimeHelper: "From 5 to 15 minutes",
    gnssMaxSearchTimeTooltip:
        "Maximum GNSS receiver operating time, in minutes",
    gnssMinSearchTime: "Minimum operating time in power saving mode",
    gnssMinSearchTimeError: "Wrong value",
    gnssMinSearchTimeHelper: "From 60 to 180 seconds in 10 second steps",
    gnssMinSearchTimeInPowersave:
        "Minimum GNSS receiver operating time in power saving mode",
    gnssMinSearchTimeTooltip:
        "GNSS receiver operating time in power saving mode, in seconds",
    gnssPowersave: "Power saving mode",
    gnssPowersaveTooltip:
        "When power saving mode is enabled, the GNSS receiver has a limited operating time",
    gnssRectificationTime: "Coordinates rectification time",
    gnssRectificationTimeHelper: "In seconds",
    gnssRectificationTimeTooltip:
        "Maximum time to determine coordinates, in seconds",
    gps: "GPS",
    gpsCoords: "GPS coordinates",
    gpsTime: "Time of GPS receiving",
    group: "Group",
    groupDelete: "Delete the group",
    groupName: "Group name",
    groupNameHelperText:
        "The group name mustn't match the name of an existing group",
    groups: "Groups",
    groupSettings: "Group settings",
    groupsNumber: "Total number of groups",
    groupTooltip: "A group in which the device will be added",
    hdop: "HDOP",
    hide: "Hide",
    hideAll: "Hide all",
    hideSideBar: "Hide the menu",
    hideTelemetry: "Hide telemetry",
    high: "High",
    human: "Human",
    hwVer: "Hardware version",
    hwVerError: "Invalid hardware version",
    ignoreHelperText: "from 00:00 to 12:00",
    ignoreTimeTooltip:
        "The time during which the motion sensor will be disabled after it is triggered",
    imei: "IMEI",
    imeiError: "Invalid IMEI",
    imeiNotExistError:
        "The device with this IMEI is not registered in the system",
    imeiTooltip:
        "IMEI is a unique device identifier (printed on the body of the device)",
    importOldDevices: "Import M-account",
    incorrectData: "Incorrect data",
    incorrectFile: "Incorrect file",
    indicators: "Indicators",
    infoAboutDevice: "Info about device",
    inputConfirmationCode: "Enter confirmation code",
    inputEmailForRecovery: "Enter your email to password recovery",
    inputGroupName: "Enter group name",
    inputLogin: "Enter your login",
    inputNameOrImei: "Enter name or IMEI",
    inputPassword: "Enter password",
    installationDate: "Installation date",
    installingPlace: "Installing place",
    internetAccess: "Internet access",
    internetSettings: "Internet settings",
    inventoryNumber: "Inventory number",
    jobTitle: "Job title",
    "km/h": "km/h",
    lac: "LAC",
    language: "Language",
    last3Days: "Last 3 days",
    last24Hours: "Last 24 hours",
    lastConnection: "Last contact",
    lastLocation: "Last location",
    lastWeek: "Last week",
    latitude: "Latitude",
    lbs: "LBS",
    lbsCoords: "LBS coordinates",
    lbsTime: "Time of LBS receiving",
    ledIndication: "LED indication",
    ledIndicationTooltip: "State of the LED indication on the device body",
    lessThan25per: "Less than 25%",
    LIGHT_DISAPPEARANCE: "Light disappearance",
    lightappearance: "Light appearance",
    lightDetect: "Light appearance",
    LightDetect: "Light appearance",
    lightdisappearance: "Light disappearance",
    LIGTH_APPEARANCE: "Light appearance",
    link: "Link",
    loading: "Loading",
    locationHistory: "Location history",
    login: "Login",
    logOut: "Logout",
    longitude: "Longitude",
    longPeriodAttention: "Attention! Recommend set up period to 1 day",
    low: "Low",
    m: "m",
    mainSim: "Main SIM card",
    mainSimTooltip:
        "SIM card with which the device tries to connect in the first place",
    manufactureYear: "Manufacture year",
    map: "Map",
    mcc: "MCC",
    medium: "Medium",
    min: "min",
    minute: "Minute",
    minutes: "Minutes",
    missing: "Missing",
    mnc: "MNC",
    mode: "Mode",
    model: "Model",
    modeTooltip_0: "Tracker — device is always in touch",
    modeTooltip_1:
        "Periodic — device get on for a contact in accordance with the periodicity specified in the settings",
    modeTooltip_2:
        "Alarm — device get on for a contact at a predetermined time",
    monitoring: "Monitoring",
    more: "More",
    moreThan50per: "More than 50%",
    MOTION_DETECT: "Motion detect",
    motiondetect: "Motion detect",
    motionSensor: "Motion sensor",
    motionAngleSensor: "Motion / Tilt sensor",
    motionSensorIgnoreTime: "Ignoring time of motion sensor after triggering",
    motionSensorIgnoreTimeError:
        "Wrong ignoring time of motion sensor after triggering",
    motionSensorModesTooltip_0:
        "Disabled — motion sensor is disabled (the device does not respond to movement)",
    motionSensorModesTooltip_1: `Always enabled — motion sensor is enabled (when motion is detected,
                                the intensity of which exceeds the set threshold, the device will send its coordinates)
                `,
    motionSensorModesTooltip_2: `Periodically enabled — motion sensor is enabled during the specified period of the day`,
    motionSensorPeriodEnd: "End of motion sensor operation period",
    motionSensorPeriodStart: "Start of motion sensor operation period",
    move: "Motion detect",
    Move: "Motion detect",
    movementState: "Movement state",
    moveToAnotherGroup: "Move to another group",
    name: "Name",
    no: "No",
    noAlarmsEnabled: "No alarms enabled",
    noData: "No data",
    noDataAboutBattery: "No data about battery status",
    noDataAboutMovementStatus: "No data about movement status",
    noDevices: "No devices",
    noRightsDeviceSettingsError: "No rights to edit settings",
    noRightsError: "No rights to add a device to the selected group",
    noSettingsError: "Settings not received yet",
    notActive: "Not active",
    notExist: "#Something",
    notExistError: "User with this email is not registered",
    notToIgnore: "Not to ignore",
    notToIgnoreTooltip: `Motion sensor doesn't disable after it has been triggered`,
    ntpAddress: "NTP server address",
    ntpAddressTooltip: "IP address or domain name of the NTP server",
    ntpPort: "NTP server port",
    ntpPortTooltip: "TCP port of the NTP server",
    number: "Number",
    objectType: "Object type",
    of: "Of",
    ok: "OK",
    openTelemetry: "Open telemetry",
    operationMode: "Operation mode",
    option: "Option",
    options: "Options",
    or: "Or",
    password: "Password",
    passwordAlertMessage: "Password must contain at least 8 characters",
    passwordConfirm: "Password confirmation",
    passwordConfirmAlertMessage: "Passwords must match",
    passwordRecover: "Recover the password",
    passwordRecovery: "Password recovery",
    passwordRecoveryConfirm: "Password recovery confirmation",
    periodEnd: "End of period",
    periodEndTooltip:
        "Time of day (according to the time zone of the device) at which the motion sensor of the device stops working",
    periodic: "Periodic message",
    Periodic: "Periodic message",
    PERIODIC: "Periodic message",
    periodicActiveTime: "Command waiting time",
    periodicActiveTimeError: "Time must be from 3 to 15 minutes",
    periodicActiveTimeHelper: "Time must be from 0 to 10 minutes",
    periodicActiveTimeMin: "Command waiting time, min",
    periodicActiveTimeTooltip:
        "Time, in minutes, during which the device will wait for a command after contacting (from 3 to 15 minutes)",
    periodicallyEnabled: "Periodically enabled",
    periodicLocationPeriod: "Coordinate determination period ",
    periodicLocationPeriodError: "Period must be greater than 1",
    periodicLocationPeriodHelper:
        "The number of communication sessions until the next determination of coordinates",
    periodicSleepDaysError: "Must be from 0 to 30",
    periodicSleepHoursError: "Must be from 0 to 23",
    periodicSleepMinutesError: "Must be from 0 to 59",
    periodicSleepTime: "Sleep time",
    periodicSleepTimeDays: "Days",
    periodicSleepTimeDaysHelper: "From 0 to 30 days",
    periodicSleepTimeDaysTooltip:
        "Number of days during which the device will be in sleep mode after the end of the session (from 0 to 30 days)",
    periodicSleepTimeError: "Minimum sleep time - 1 minute",
    periodicSleepTimeHelper: "Time must be from 1 to 1440 minutes",
    periodicSleepTimeHours: "Hours",
    periodicSleepTimeHoursHelper: "From 0 to 23 hours",
    periodicSleepTimeHoursTooltip:
        "Number of hours during which the device will be in sleep mode after the end of the session (from 0 to 23 hours)",
    periodicSleepTimeMin: "Sleep time, min",
    periodicSleepTimeMinutes: "Minutes",
    periodicSleepTimeMinutesHelper: "From 0 to 59 minutes",
    periodicSleepTimeMinutesTooltip:
        "Number of minutes during which the device will be in sleep mode after the end of the session (from 0 to 59 minutes)",
    periodicSleepTimeTooltip:
        "Time, in minutes, during which the device will be in sleep mode after the end of the session (from 1 to 1440 minutes)",
    periodStart: "Start of period",
    periodStartAndEndError: `Start and end of motion sensor operation period can't be the same`,
    periodStartTooltip:
        "Time of day (according to the time zone of the device) at which the motion sensor of the device starts working",
    phoneNumSim1: "Phone number to send with SIM 1",
    phoneNumSim1Tooltip: "Phone number to which data will be sent from SIM 1",
    phoneNumSim2: "Phone number to send with SIM 2",
    phoneNumSim2Tooltip: "Phone number to which data will be sent from SIM 2",
    pm: "Periodic mode",
    port: "Port",
    present: "Present",
    privacyPolicy: "Policy of personal data",
    privacyPolicy_1: "(Privacy policy)",
    privacyPolicyAcceptance_1: "privacy policy",
    privacyPolicyAcceptance: "You are agree with",
    privacyPolicyError: `You didn't agree with privacy policy`,
    protocol: "Protocol",
    recover: "Recover",
    recoverThePassword: "Recover password",
    registerError: "User with this email is already registered",
    registration: "Registration",
    report: "Report",
    reports: "Reports",
    requestAgain: "Request again",
    resetSettings: "Reset settings",
    rowsPerPage: "Rows per page",
    s: "s",
    satellitesNumber: "Number of satellites",
    save: "Save",
    saveAlertMessage: "Settings have been successfully saved",
    saveDescriptionAlertMessage: "Description was successfully changed",
    saveDeviceAdding: "Device was successfully added",
    selectGroupToMoveInDevice:
        "Select the group you want to move the device to",
    send: "Send",
    sendCommandsShort: "Send commands",
    sendCommands: "Rights to send commands to the device",
    sensorIgnoreTime: "Ignoring time after triggering",
    server1: "Server №1",
    server2: "Server №2",
    server3: "Server №3",
    serverAddress: "Server address",
    serverAddressTooltip: "IP address or domain name of the server",
    serverError: "Server error",
    serverPassword: "Password",
    serverPasswordTooltip: "Password to access the server",
    serverPort: "Port",
    serverPortTooltip:
        "TCP port on which the device should communicate with the server",
    serverProtocolTooltip: "Communication protocol between server and device",
    serverStateTooltip: "Send data over the Internet to",
    setComputerTimezone: "Set computer timezone",
    settings: "Settings",
    settingsIsApplied: "Settings has been sent to device",
    settingsIsNotApplied:
        "Settings has been saved at the server and it will be sent to device in the next communication session",
    share: "Share",
    shareDeviceSettingsTitle: "Share device settings",
    shareSettings: "Share settings",
    showAll: "Show all",
    showSideBar: "Show menu",
    showTelemetry: "Show telemetry",
    signal: "Signal level, ASU",
    signIn: "Sign in",
    signUp: "Sign up",
    sim1pr: "SIM 1 presence",
    sim2pr: "SIM 2 presence",
    simApn: "APN SIM",
    simApnTooltip: "Access point name SIM",
    simCard: "SIM card",
    simLogin: "Login SIM",
    simLoginTooltip: "Login to connect to access point SIM",
    simPassword: "Password SIM",
    simPasswordTooltip: "Password to connect to access point SIM",
    smsFormat: "Data format",
    smsFormatSending: "SMS data transfer format",
    smsFormatTooltip_0: "Link — SMS sends a link to the data",
    smsFormatTooltip_1: "Text — SMS sends data in text format",
    smsState: "Sending data via SMS",
    smsStateTooltip: "Send data as SMS messages",
    sortByAsc: "Sort by ascending",
    sortByDesc: "Sort by descending",
    speed: "Speed",
    statistics: "Statistics",
    stop: "Stop detect",
    Stop: "Stop detect",
    STOP_DETECT: "Stop detect",
    stopdetect: "Stop detect",
    subuser: "User",
    subuserDevicesTitle: `User's devices`,
    subuserRegisterError: "User with this login is already registered",
    subusers: "Users",
    support: "Support",
    swVer: "Software version",
    swVerError: "Invalid software version",
    tab: "Tab",
    technique: "Technique",
    techniqueKind: "Technique kind",
    techniqueModel: "Technique model",
    techniqueNumber: "Technique number",
    techSupport: "Tech support",
    telemetry: "Telemetry",
    telemetryTime: "Time of telemetry receiving",
    temperature: "Temperature",
    text: "Text",
    timeAndDatePickerTitle: "Select date & time",
    timePickerCancel: "Cancel",
    timePickerOk: "OK",
    timePickerTitle: "Select time",
    timerText: "You can re-request a confirmation code through:",
    timeSync: "Time sync",
    timeSyncGsmState: "Time setting up by GSM",
    timeSyncGsmStateTooltip:
        "Device time is corrected according to data receiving via GSM",
    timeSyncNtpState: "Time setting up by NTP",
    timeSyncNtpStateTooltip:
        "Device time is corrected according to data receiving from the NTP server",
    timeSyncSatsState: "Time setting up by satellites",
    timeSyncSatsStateTooltip:
        "Device time is corrected according to data receiving from GNSS satellites",
    timezone: "Timezone",
    toDate: "To",
    toGenerate: "Generate",
    topic: "Topic",
    tracker: "Tracker",
    Tracker: "Tracker",
    LightSensorLight: "Appearance of light",
    lightsensorlight: "Appearance of light",
    LightSensorDark: "Loss of light",
    lightsensordark: "Loss of light",
    Tilt: "Tilt",
    tilt: "Tilt",
    trackMode: "Track mode",
    trailer: "Trailer",
    trailerNumber: "Licence plate number",
    trailerVin: "VIN number",
    type: "Type",
    unsort: "Unsort",
    update: "Update",
    updateServer: "Update server",
    updateServerAddress: "Address of update server ",
    updateServerDir: "Directory of update file",
    updateServerFile: "Name of update file",
    updateServerLogin: "Login of update server",
    updateServerPassword: "Password of update server",
    updateServerPort: "Port of update server",
    uploadFromFile: "Upload from a file",
    V: "V",
    value: "Value",
    VegaMX: "Vega MX",
    visibilitySettings: "Visibility settings",
    waitForSmsCommand: "Wait for SMS command",
    wakeUpTime: "Wake up time",
    wakeUpTimeTooltip:
        "Time of day (according to time zone of the device) at which the device will communicate",
    "Wialon IPS 2.0": "Wialon IPS 2.0",
    wrongConfirm: "Invalid confirmation code",
    wrongContent: "Enter content",
    wrongGroupName: "Invalid group name",
    wrongPasswordError: "Wrong password",
    wrongTopic: "Enter the topic",
    yes: "Yes",
    lightSensor: "Light Sensor",
    lightSensorIgnoreTime: "Light Sensor Ignore Time After Activation",
    lightSensorIgnoreTimeError:
        "Invalid light sensor ignore time after activation",
    lightSensorModesTooltip_0:
        "Disabled — the light sensor is off (the device does not respond to illumination)",
    lightSensorModesTooltip_1:
        "Always Enabled — the light sensor is on (when the illumination changes, the device will send its coordinates)",
    lightSensorModesTooltip_2:
        "Active During Period — the light sensor is enabled during the specified time period",
    lightSensorPeriodEnd: "Light Sensor Period End",
    lightSensorPeriodStart: "Light Sensor Period Start",
    ignoreLightTimeTooltip:
        "Time during which the motion sensor will be deactivated after it is triggered",
    notToIgnoreLightTooltip:
        "The light sensor does not switch off after it has been activated",
    lightModeRising: "Light appears",
    lightModeFalling: "Light fading",
    triggeringMode: "Trigger mode",
    lightPeriodStartAndEndError:
        "The start and end of the light sensor operating period must not be the same",
    motionMode: "Motion sensor",
    angleMode: "Angle sensor",
    motionOrAngle: "Sensor Mode",
    sensorModesTooltip: "Sensor mode of operation, detect motion or tilt",
    triggerAngle: "sensor response angle",
    holdingAngleTime: "Angle retention time before actuation",
    second: "second",
    geozones: "Geozones",
};

export default EN;
